import { createSlice } from "@reduxjs/toolkit";
const { api_url } = require("../settings");

export const references = createSlice({
  name: "references",
  initialState: {
    url: api_url + "references/bibliography/",
    es: {
      title: `<h1 class="references-title">Referencias - Sistema de monitoreo de la movilidad</h1>`,
      content_production: `
            <h2 class="references-section-title">Contenido y realización</h2>
            <p>
            Esta herramienta de seguimiento forma parte del sistema de monitoreo de la movilidad de Cusco. Se ha desarrollado en el marco del Estudio de Planificación de Transporte y Tránsito para la Movilidad Urbana Sostenible y Espacios Públicos en Cusco, bajo la dirección ejecutiva del Gobierno Regional de Cusco (GoRe), COPESCO, PRODER y Municipalidad Provincial de Cusco (MPC). La plataforma digital se basa en la desarrollada inicialmente en el marco de los Observatorios de la India.
            </p>`,
      technical_development: `<h2 class="references-section-title">Desarrollo técnico de la plataforma por Oslandia.</h2>
            <p>
            Sistema de gestión: ReactJS / Python Flask / OpenLayers / ChartJS / Postgres / Postgis
            Oslandia. Geographical Information Systems. 4 Place Louis Armand, 75012 Paris, France |
            <a href="https://oslandia.com/">https://oslandia.com/</a>
            </p>`,
      bibliography: `<h2 class="references-section-title">Bibliografía</h2>
        <p>
        Disponible en la página web Cuscosemueve : <a target="_blank" href="https://cuscosemueve.pe/documentosfinales">https://cuscosemueve.pe/documentosfinales</a>
        </p>`,
    },
  },
});

export default references.reducer;
